
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

// Data Transfer Submit Thunk
export const SubmitDataTransfer = createAsyncThunk(
    'datatransfer/submit',
    async (staticIP, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/mongotosql/${staticIP}`);

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


// --- Redux Slice ---
const DataTransferSlice = createSlice({
    name: 'datatransfer',
    initialState: {

        // For Transfer Submission
        transferData: false,
        transferLoading: false,
        transferError: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(SubmitDataTransfer.pending, (state) => {
                state.transferLoading = true;
                state.transferError = null;
            })
            .addCase(SubmitDataTransfer.fulfilled, (state, action) => {
                state.transferLoading = false;
                state.transferData = action.payload;
            })
            .addCase(SubmitDataTransfer.rejected, (state, action) => {
                state.transferLoading = false;
                state.transferError = action.payload;
            })

    }
});

// Export the reducer
export default DataTransferSlice.reducer;